import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

// Shared header banner for internal pages (About, Contact, Team, SSS,
// legal pages, ...). Keeps breadcrumb + title styling consistent with
// the photo hero used on Category.jsx without needing an image.
export default function PageBanner({ eyebrow, title, subtitle, breadcrumb = [] }) {
  return (
    <section className="relative overflow-hidden bg-[#FBF9F4] border-b border-[#EAEAEA]" data-testid="page-banner">
      <div className="absolute -top-24 -right-16 w-72 h-72 rounded-full bg-[#A85C34]/5 blur-3xl pointer-events-none" />
      <div className="absolute -bottom-24 -left-16 w-72 h-72 rounded-full bg-[#D4A15C]/10 blur-3xl pointer-events-none" />

      <div className="frida-container relative py-14 md:py-20">
        <nav className="flex items-center gap-2 text-xs text-[#888888] mb-5 flex-wrap" data-testid="page-breadcrumb">
          <Link to="/" className="hover:text-[#A85C34] transition-colors">Ana Sayfa</Link>
          {breadcrumb.map((b, i) => (
            <span key={i} className="flex items-center gap-2">
              <ChevronRight className="w-3 h-3 shrink-0" />
              {b.to ? (
                <Link to={b.to} className="hover:text-[#A85C34] transition-colors">{b.label}</Link>
              ) : (
                <span className="text-[#222222]">{b.label}</span>
              )}
            </span>
          ))}
        </nav>

        {eyebrow && (
          <div className="text-xs tracking-[0.25em] uppercase text-[#A85C34] font-medium mb-3">
            · {eyebrow} ·
          </div>
        )}
        <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl text-[#222222] tracking-tight leading-[1.1] max-w-3xl">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-4 text-[#555555] text-lg max-w-2xl leading-relaxed">{subtitle}</p>
        )}
      </div>
    </section>
  );
}
